module.exports = __webpack_public_path__ + "static/media/rolletexp1.7969fe09.jpg";